import Loadable from 'react-loadable';
import NotFoundRedirect from 'views/components/not-found-redirect';
import ScreenLoading from 'views/ui/screen-loading';
import { getWorkoutProgram } from 'modules/workout-program/actions';
import { listRegions } from 'modules/regions/actions';
import { locationList } from 'modules/location/actions';
import { stopPolling } from 'modules/station-equipments/actions';

const Login = Loadable({
  loader: () => import('views/screens/login'),
  loading: () => ScreenLoading,
});

const ContainerApp = Loadable({
  loader: () => import('views/containers/app'),
  loading: () => ScreenLoading,
});

const VideoConsole = Loadable({
  loader: () => import('views/screens/video-console'),
  loading: () => ScreenLoading,
});

const Library = Loadable({
  loader: () => import('views/screens/library'),
  loading: () => ScreenLoading,
});
const StationsMonitoring = Loadable({
  loader: () => import('views/screens/station-monitoring'),
  loading: () => ScreenLoading,
});
const ResetPassword = Loadable({
  loader: () => import('views/screens/reset-password'),
  loading: () => ScreenLoading,
});
const WorkoutProgram = Loadable({
  loader: () => import('views/screens/workout-program'),
  loading: () => ScreenLoading,
});
const ShiftManager = Loadable({
  loader: () => import('views/screens/shift-manager'),
  loading: () => ScreenLoading,
});

const routes = [
  {
    path: '/',
    component: Login,
    exact: true,
    published: true,
  },
  {
    path: '/app',
    component: ContainerApp,
    privated: true,
    actions: [],
    routes: [
      // `permissions` mirrors the ability checks the header nav makes, so a URL
      // typed or bookmarked directly is gated the same way as the link to it.
      {
        path: '/app/video-console',
        component: VideoConsole,
        exact: true,
        permissions: [['*', 'videos']],
        actions: [locationList, listRegions, stopPolling],
      },
      {
        path: '/app/library',
        component: Library,
        exact: true,
        permissions: [['*', 'library']],
        actions: [stopPolling],
      },
      // These 3 are routes that are also used for non admin / standard users
      {
        path: '/app/stations-monitoring',
        component: StationsMonitoring,
        exact: true,
        permissions: [['*', 'monitoring']],
        actions: [locationList],
      },
      {
        path: '/app/workout-program',
        component: WorkoutProgram,
        exact: true,
        actions: [getWorkoutProgram, locationList],
      },
      {
        path: '/app/shift-manager',
        component: ShiftManager,
        exact: true,
        actions: [locationList],
      },
      {
        name: '404',
        path: '*',
        component: NotFoundRedirect,
      },
    ],
  },
  {
    path: '/reset-password/:token',
    component: ResetPassword,
    exact: true,
  },
  {
    name: '404',
    path: '*',
    component: NotFoundRedirect,
  },
];

export default routes;
